import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./TicketAssessments.css";
axios.defaults.withCredentials = true;

const StarRating = ({ value }) => {
  const stars = Array.from({ length: 5 }, (_, i) => (
    <span key={i} className={i < value ? "star filled" : "star"}>
      ★
    </span>
  ));
  return <div className="stars">{stars}</div>;
};

const TicketAssessments = () => {
  const [assessments, setAssessments] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 30;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await axios.get(
          "/ticketadmin/assessments",
          {
            withCredentials: true,
          },
        );
        setAssessments(res.data);
      } catch (err) {
        console.error("Error fetching assessments", err);
      }
    };
    fetchData();
  }, []);

  const totalPages = Math.ceil(assessments.length / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const paginatedAssessments = assessments.slice(
    startIndex,
    startIndex + ITEMS_PER_PAGE,
  );

  return (
    <div className="assessment-container">
      <h2 className="cus-info-title">Ticket Assessments</h2>
      <div className="assessment-table-wrap">
        <table className="assessment-table">
          <thead>
            <tr>
              <th>Ticket</th>
              <th>Subject</th>
              <th>Customer</th>
              <th>การบริการ</th>
              <th>ความรวดเร็ว</th>
              <th>ความพึงพอใจ</th>
              <th>Avg Score</th>
              <th>Date</th>
            </tr>
          </thead>

          <tbody>
            {paginatedAssessments.map((item) => {
              const avgScore = (
                (Number(item.Q1) + Number(item.Q2) + Number(item.Q3)) /
                3
              ).toFixed(2);

              return (
                <tr key={item.id}>
                  <td>
                    <Link
                      to={`/admin/ticketadmin/${item.ticket_id}`}
                      className="assessment-ticket-link"
                    >
                      #{item.ticket_id}
                    </Link>
                  </td>
                  <td>{item.issue_summary}</td>
                  <td>{item.customer_name}</td>
                  <td>
                    <StarRating value={item.Q1} />
                  </td>
                  <td>
                    <StarRating value={item.Q2} />
                  </td>
                  <td>
                    <StarRating value={item.Q3} />
                  </td>
                  <td>{avgScore}</td>
                  <td>
                    {new Date(item.created_at).toLocaleString("th-TH", {
                      timeZone: "Asia/Bangkok",
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <div className="ticket-pagination">
          <button
            onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          {Array.from({ length: totalPages }, (_, index) => {
            const page = index + 1;
            return (
              <button
                key={page}
                onClick={() => setCurrentPage(page)}
                className={currentPage === page ? "active-page" : ""}
              >
                {page}
              </button>
            );
          })}

          <button
            onClick={() =>
              setCurrentPage((prev) => Math.min(prev + 1, totalPages))
            }
            disabled={currentPage === totalPages}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default TicketAssessments;
